module.exports = __webpack_public_path__ + "img/characterAnime7.c7a09204.png";